<template>
    <div v-if="disabled()" class="quantity-block">
        <div class="price">
            <span class="price-integer">{{ intTotalPrice }}</span>
            <span class="price-decimal">{{ decTotalPrice }}</span>
            <span class="price-currency"> грн</span>
        </div>
        <div class="quantity-items d-flex flex-row justify-content-between">
            <div class="d-flex flex-column align-items-center">
                <div v-if="pack && minPackQuantity.value > 1" class="quantity-name">{{ pack }}</div>
                <div class="quantity d-flex ">
                    <button class="minus quant-btn" @click.prevent="decrement()">-</button>
                    <input type="number" ref="full" name="quant" v-model.number="innerValue.fullQuantity" @input="onInput"
                           class="quant-input">
                    <button class="plus quant-btn" @click.prevent="increment()">+</button>
                </div>
            </div>
            <div class="d-flex flex-column align-items-center">
                <div v-if="minPack.value && minPackQuantity.value > 1" class="quantity-name">{{ minPack.value }}</div>
                <div v-if="minPackQuantity.value > 1" class="quantity d-flex">
                    <button class="minus quant-btn" @click.prevent="decrementPart()">-</button>
                    <input type="text" ref="part" name="partquant" v-model.number="innerValue.partQuantity" disabled
                           class="quant-input">
                    <button class="plus quant-btn" @click.prevent="incrementPart()">+</button>
                </div>
            </div>
        </div>
        <div class="buy-ostatok">Залишилось {{ product.remnants_sum_quantity || 0 }} {{ product.unit_type }}.</div>
    </div>
</template>

<script>
export default {
    name: "ProductQuantity",
    props: {
        modelValue: Object,
        product: Object,
        characteristics: Object,
    },
    emits: ['update:modelValue'],
    data() {
        return {
            totalPrice: 0
        }
    },
    mounted() {
        const productInCart = this.$store.getters['cart/getItemInCartById'](this.product.id);
        if (!productInCart) {
            if (this.minPackQuantity)
                this.innerValue.packQuantity = 1 * this.minPackQuantity.value

            if (this.pack)
                this.innerValue.pack = this.pack.value

            if (this.minPack)
                this.innerValue.minPack = this.minPack.value
        }

        if (this.product.remnants_sum_quantity < 1) {
            this.innerValue.fullQuantity = 0
            if (this.innerValue.packQuantity > 1) {
                this.innerValue.partQuantity = 0
                const fractionPart = parseInt(this.product.remnants_sum_quantity * this.innerValue.packQuantity)
                if (fractionPart <= this.innerValue.packQuantity) {
                    this.innerValue.partQuantity = fractionPart
                }
            }
        }

        this.countTotalQuantity()
        this.countTotalPrice()
    },
    methods: {
        disabled() {
            return this.product.quantity > 0 && this.product.price > 0
        },
        countTotalPrice() {
            this.totalPrice = parseFloat((this.product.order_price * this.innerValue.totalQuantity).toFixed(2))
        },
        countTotalQuantity() {
            if (this.innerValue.packQuantity > 1) {
                let partQuantity = 0
                if (this.innerValue.partQuantity > 0) {
                    partQuantity = this.innerValue.partQuantity / this.innerValue.packQuantity
                }
                this.innerValue.totalQuantity = parseFloat((this.innerValue.fullQuantity + partQuantity).toFixed(4))
            } else {
                this.innerValue.totalQuantity = this.innerValue.fullQuantity
            }
        },
        increment() {
            if (this.product.remnants_sum_quantity > 1) {
                if (parseInt(this.product.remnants_sum_quantity) <= this.innerValue.fullQuantity + 1) {
                    this.innerValue.fullQuantity = parseInt(this.product.remnants_sum_quantity)
                    const fraction = this.product.remnants_sum_quantity - parseInt(this.product.remnants_sum_quantity)
                    if (fraction > 0) {
                        this.innerValue.partQuantity = 0
                        this.$refs.part.value = 0
                    }
                } else {
                    this.innerValue.fullQuantity += 1
                }
            } else if (this.product.remnants_sum_quantity === 1) {
                this.innerValue.fullQuantity = 1
            }  else {
                this.innerValue.fullQuantity = 0
            }
            this.countTotalQuantity()
            this.countTotalPrice()
        },
        decrement() {
            if (this.innerValue.fullQuantity === 1 && this.minPackQuantity.value <= 1) {
                this.innerValue.fullQuantity = 1;
                this.countTotalQuantity()
                this.countTotalPrice()
                return
            }

            if (this.innerValue.fullQuantity === 0 && this.partQuantity === 1) {
                this.countTotalQuantity()
                this.countTotalPrice()
                return
            }

            this.innerValue.fullQuantity -= 1;
            if (this.innerValue.fullQuantity <= 0 && this.innerValue.partQuantity <= 0) {
                this.innerValue.fullQuantity = 0
                this.innerValue.partQuantity += 1
            } else if (this.innerValue.fullQuantity <= 0) {
                this.innerValue.fullQuantity = 0
            }
            this.countTotalQuantity()
            this.countTotalPrice()
        },
        incrementPart() {
            if (this.product.remnants_sum_quantity > 1) {
                if (this.product.remnants_sum_quantity < this.innerValue.fullQuantity + 1) {
                    this.innerValue.fullQuantity = parseInt(this.product.remnants_sum_quantity)
                    const fraction = this.product.remnants_sum_quantity - parseInt(this.product.remnants_sum_quantity)
                    if (fraction > 0) {

                        let fractionPart = fraction * this.minPackQuantity.value
                        const roundedNum = Math.round(fractionPart * 10) / 10
                        if (Math.abs(fractionPart - roundedNum) <= 0.03) {
                            fractionPart = roundedNum;
                        }

                        if (fractionPart <= this.innerValue.packQuantity) {
                            if (this.innerValue.partQuantity < fractionPart) {
                                this.innerValue.partQuantity += 1
                            }
                        }
                    }
                    this.countTotalQuantity()
                    this.countTotalPrice()
                    return
                }
            }
            if (this.product.remnants_sum_quantity < 1) {
                const fractionPart = parseInt(this.product.remnants_sum_quantity * this.innerValue.packQuantity)
                if (this.innerValue.partQuantity < fractionPart) {
                    this.innerValue.partQuantity += 1
                }

                this.countTotalQuantity()
                this.countTotalPrice()
                return
            }
            if (this.product.remnants_sum_quantity === this.innerValue.fullQuantity) {
                this.innerValue.partQuantity = 0
                this.countTotalQuantity()
                this.countTotalPrice()
                return
            }
            if (parseInt(this.innerValue.partQuantity) === this.innerValue.packQuantity) {
                this.innerValue.partQuantity = 0
                this.innerValue.fullQuantity += 1
                this.countTotalQuantity()
                this.countTotalPrice()
                return
            }

            this.innerValue.partQuantity += 1
            if (parseInt(this.innerValue.partQuantity) === parseInt(this.minPackQuantity.value)) {
                this.innerValue.partQuantity = 0
                this.innerValue.fullQuantity += 1
            }
            this.countTotalQuantity()
            this.countTotalPrice()
        },
        decrementPart() {
            if (this.innerValue.fullQuantity >= 1 && this.innerValue.partQuantity === 0) {
                this.innerValue.fullQuantity -= 1
                if (this.innerValue.fullQuantity <= 0) {
                    this.innerValue.fullQuantity = 0
                }
                this.innerValue.partQuantity = this.innerValue.packQuantity - 1
                this.countTotalQuantity()
                this.countTotalPrice()
                return
            }
            if (this.innerValue.fullQuantity === 0 && this.innerValue.partQuantity === 1) {
                this.countTotalQuantity()
                this.countTotalPrice()
                return
            }
            this.innerValue.partQuantity -= 1
            if (parseInt(this.innerValue.partQuantity) <= 0) this.innerValue.partQuantity = 0
            this.countTotalQuantity()
            this.countTotalPrice()
        },
        onInput(event) {
            let inputValue = parseInt(event.target.value)

            if (!isNaN(inputValue) && inputValue > 0) {
                if (!this.product.remnants_sum_quantity) {
                    this.$refs.full.value = 0
                    this.innerValue.fullQuantity = 0
                    this.innerValue.partQuantity = 0
                } else {

                    if (inputValue >=  parseInt(this.product.remnants_sum_quantity)) {
                        this.$refs.full.value = parseInt(this.product.remnants_sum_quantity)
                        this.innerValue.fullQuantity = parseInt(this.product.remnants_sum_quantity)

                        const fraction = this.product.remnants_sum_quantity - parseInt(this.product.remnants_sum_quantity)
                        if (fraction > 0) {
                            const fractionPart = parseInt(fraction * this.minPackQuantity.value)
                            if (fractionPart <= this.innerValue.packQuantity ) {
                                this.innerValue.partQuantity = 0
                            }
                        }
                    }

                    if (inputValue < 1) {
                        this.$refs.full.value = 1
                        this.innerValue.fullQuantity = 1
                        this.innerValue.partQuantity = 0
                    }
                }
            } else {
                this.innerValue.fullQuantity = 1
            }

            this.countTotalQuantity()
            this.countTotalPrice()
        },
    },
    computed: {
        pack() {
            return 'упаковка'
        },
        minPack() {
            const [result] = Object.entries(this.characteristics).filter(([_, innerObj]) => innerObj['name'] === 'Первинна упаковка')
            return result ? result[1] : { value: 'частина'}
        },
        minPackQuantity() {
            const [result] = Object.entries(this.characteristics).filter(([_, innerObj]) => innerObj['name'] === 'Кількість первинних упаковок')
            return result ? result[1] : { value: 0 }
        },
        quantity() {
            return this.product.remnants_sum_quantity || 0;
        },
        innerValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                console.log('innerValue set', value)
            }
        },
        intTotalPrice() {
            return Math.floor(this.totalPrice)
        },
        decTotalPrice() {
            return `.${this.totalPrice.toFixed(2).slice(-2)}`
        },
    },
}
</script>

<style lang="scss" scoped>
/* Webkit (Chrome, Safari, etc.) */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  margin: 0;
}

/* Mozilla (Firefox) */
input[type="number"] { -moz-appearance: textfield; }

.price {
    margin: 12px 0 12px 0;
    line-height: 100%;
    font-weight: bold;
    color: #212E42;
    white-space: nowrap;
}

.price .price-integer {
  font-size: 1.8em;
}

.price .price-decimal {
  font-size: 1.4em;
  position: relative;
}

.price .price-currency {
  font-size: 1.8em;
}

.quantity {
  min-width: 140px;
  max-width: 140px;
}

.quantity-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 8em;
}

.quantity .quant-btn {
  min-width: 50px;
}

.quantity .quant-input {
  width: 40px;
}

</style>